import React from "react";

const Maintenance: React.FC = () => {
  return <div>メンテナンス中です。しばらくお待ちください。</div>;
};

export default Maintenance;
